import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  postPricesCategories,
  type SavePriceCategoryRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PRICE_CATEGORIES_QUERY_KEYS } from "PriceCategories/Api/Queries/queryKeys";

export function useCreatePriceCategoryMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SavePriceCategoryRequest) =>
      postPricesCategories(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PRICE_CATEGORIES_QUERY_KEYS.all,
      });
    },
  });
}
